import { Component } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UISelect from 'UIComponents/input/UISelect';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import UIMicroDateRange from 'UIComponents/dates/UIMicroDateRange';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';

// @ts-expect-error untyped module
import ConnectedAPIDropdown from 'customer-data-reference-ui-components/connector/ConnectedAPIDropdown';
// @ts-expect-error untyped module
import { USER } from 'reference-resolvers/constants/ReferenceObjectTypes';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import withTrackEvent from 'automation-ui-usage-tracking/TrackEventDecorator';
import { presetOptionResolver, toDateStringFromSimpleDate } from 'automation-ui-management/utils/dateRangeUtils';
import { Timezones } from 'automation-ui-management/constants/DateConstants';
import AuditEventHistoryFilterKeys from 'automation-ui-management/records/AuditHistory/AuditEventHistoryFilterKeys';
import { ALL_FILTER } from 'automation-ui-management/records/AuditHistory/AuditEventHistoryFilters';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
class AuditHistoryFilters extends Component {
  constructor(...args) {
    super(...args);
    this.handleEventTypeFilterChange = ({
      target: {
        value: {
          value: filterValue
        }
      }
    }) => {
      const {
        onFilterChange,
        trackEvent
      } = this.props;
      onFilterChange(AuditEventHistoryFilterKeys.EVENT_TYPE, filterValue);
      trackEvent(Trackables.HISTORY_FILTERS_EVENT_TYPE, {
        filterValue
      });
    };
    this.handleUserIdFilterChange = ({
      target: {
        value: filterValue
      }
    }) => {
      const {
        onFilterChange,
        trackEvent
      } = this.props;
      onFilterChange(AuditEventHistoryFilterKeys.USER_ID, filterValue);
      trackEvent(Trackables.HISTORY_FILTERS_USER);
    };
    this.handleDateRangeChange = ({
      target: {
        value: filterDateRange
      }
    }) => {
      const {
        onFilterChange,
        trackEvent
      } = this.props;
      onFilterChange(AuditEventHistoryFilterKeys.RANGE_TYPE, filterDateRange);
      trackEvent(Trackables.HISTORY_FILTERS_DATE_RANGE, {
        filterValue: filterDateRange.type,
        startDate: toDateStringFromSimpleDate(filterDateRange.startDate),
        endDate: toDateStringFromSimpleDate(filterDateRange.endDate)
      });
    };
  }
  renderClearAll() {
    const {
      filters,
      onClearFilters
    } = this.props;
    if (!filters.filtersAreApplied()) {
      return null;
    }
    return /*#__PURE__*/_jsx(UILink, {
      onClick: onClearFilters,
      className: "m-left-4",
      "data-test-id": "platform-history-audit-events-clear-filters",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.auditHistoryFilters.clearFilters"
      })
    });
  }
  render() {
    const {
      filters,
      eventTypeFilterOptions,
      defaultCustomDateRange
    } = this.props;
    const USER_FILTER_OPTIONS = [{
      text: I18n.text('automation-ui-management.auditHistoryFilters.userOptions.all'),
      value: ALL_FILTER
    }];
    const DateFilter = /*#__PURE__*/_jsx(UIInlineLabel, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.auditHistoryFilters.dateRange"
      }),
      children: /*#__PURE__*/_jsx(UIMicroDateRange, {
        tz: Timezones.PORTAL_TZ,
        onChange: presetOptionResolver(this.handleDateRangeChange),
        value: filters.getDateRangeFilter(),
        defaultValue: defaultCustomDateRange,
        "data-test-id": "platform-history-audit-events-time-range-filter"
      })
    });
    const EventTypeFilter = /*#__PURE__*/_jsx(UIInlineLabel, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.auditHistoryFilters.event"
      }),
      children: /*#__PURE__*/_jsx(UISelect, {
        buttonUse: "transparent",
        menuStyle: {
          minHeight: 350
        },
        menuWidth: 250,
        onSelectedOptionChange: this.handleEventTypeFilterChange,
        options: eventTypeFilterOptions,
        value: filters.getEventTypeFilter(),
        "data-test-id": "platform-history-audit-events-event-type-filter"
      })
    });
    const UserFilter = /*#__PURE__*/_jsx(UIInlineLabel, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.auditHistoryFilters.user"
      }),
      children: /*#__PURE__*/_jsx(Flex, {
        as: "div",
        paddingInlineStart: "200",
        children: /*#__PURE__*/_jsx(ConnectedAPIDropdown, {
          referenceObjectType: USER,
          buttonUse: "link",
          menuWidth: 250,
          onChange: this.handleUserIdFilterChange,
          options: USER_FILTER_OPTIONS,
          value: filters.getUserIdFilter(),
          "data-test-id": "platform-history-audit-events-user-filter"
        })
      })
    });
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UIPanelSection, {
        flush: true,
        children: DateFilter
      }), /*#__PURE__*/_jsxs(UIPanelSection, {
        children: [EventTypeFilter, UserFilter, this.renderClearAll()]
      })]
    });
  }
}
export default withTrackEvent(AuditHistoryFilters);